import * as React from "react"
const Action = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={43}
    height={43}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="m41.95 2.07-.265-.53-.53-.264c-.264 0-6.618-2.118-11.119 2.382L12.3 21.131c-2.382-1.589-4.5-3.177-4.765-2.648l-1.059.794c-.529.53 2.383 4.5 4.766 7.148l-6.619 9.001a2.077 2.077 0 0 0-2.912 0l-.794.794a2.077 2.077 0 0 0 0 2.912l2.647 2.648a2.077 2.077 0 0 0 2.912 0l.795-.794a2.077 2.077 0 0 0 0-2.913l9.265-6.618c2.648 2.383 6.619 5.295 7.148 4.765l1.059-1.059c.265-.264-1.06-2.647-2.912-4.765L39.567 12.66c4.5-3.97 2.382-10.324 2.382-10.589ZM20.505 28.543l-2.118-2.118L34.802 8.16 16.535 24.572l-1.853-1.853L31.89 5.512c2.647-2.648 6.088-2.118 7.677-1.854.264 1.589.794 5.03-1.853 7.413L20.506 28.543Z"
    />
  </svg>
)
export default Action